import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaAppBar from './VaAppBar.vue'

export default withConfigTransport(VaAppBar)
